import caseConverter from 'change-case';

/**
 * convert all keys of obj to snake case
 * @param {*} obj 
 */
export function snakelize(obj) {
    let res = {};
    if(!obj) return res;
    Object.keys(obj).forEach(key => {
        res[caseConverter.snakeCase(key)] = obj[key];
    });

    return res;
}

/**
 * convert all keys of obj to camel case
 * @param {*} obj 
 */
export function camelize(obj) {
    let res = {};
    if(!obj) return res;
    Object.keys(obj).forEach(key => {
        res[caseConverter.camelCase(key)] = obj[key];
    });

    return res;
}